module.exports = __webpack_public_path__ + "assets/sony-8abaa0f86d1fdb31fef07f8389c0329a.svg";